import {
  subChangeTypePayment,
  subChangePlanePrice,
} from '../actions/subscription';

import { NGO } from '../constants';

import ReduxAction from '../../../interfaces/ReduxAction';

export default function changeTypePayment (value: string): ReduxAction {
  return (dispatch): void => {
    if (value === NGO) {
      dispatch(subChangePlanePrice(0));
    }
    dispatch(subChangeTypePayment(value));
  };
}
